<template>
  <div>
    <div class="page">
      <el-collapse v-model="activeNames" class="collapse-main-content">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              抄表登记
            </div>
          </template>
          <div class="collapse-content">
            <sirui-search
              ref="baseInfoFormRef"
              :query="form"
              :columns="formColumn"
              :rules="rules"
              :isQueryPanel="false"
              style="width: 100%"
            ></sirui-search>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              附件上传
            </div>
          </template>
          <div class="collapse-content">
            <FileTable ref="fileTableRef" :attachments="storageAttachment" />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!-- 底部按钮 fixme需要判断立项状态显示-->
    <footer class="bottomButtons">
      <div style="padding: 20px; background: #fff">
        <el-row class="page-row">
          <el-button type="primary" @click="confirmClick">确认</el-button>
          <el-button type="primary" @click="cancelClick" plain>取消</el-button>
        </el-row>
      </div>
    </footer>
  </div>
</template>
<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import MeterAPI from '@/api/property/meterManagement';
  import FileTable from '@/components/business/FileTable/index.vue';
  import moment from 'moment';
  import { registerColumns } from './columns/columns.js';
  export default {
    name: 'MeterReadRegister',
    components: { SiruiSearch, FileTable },
    computed: {
      formColumn() {
        return registerColumns(this);
      },
    },
    data() {
      return {
        activeNames: ['1', '2'],
        storageAttachment: [], //附件列表
        form: {
          companyCode: '',
          spaceAreaId: '', //区域
          spaceAssetId: '', //资产
          spaceUnitId: '', //单元
          spaceFloorId: '', //楼层
          spaceId: '', //房号
          customerName: '', //客户名称
          customerCode: '',
          electricMeterNo: '', //电表编号
          electricMeterType: '', //电表类型
          readMeterDate: '', //起始月份
          loss: '', //损耗
          inductanceRatio: '', //电感比/倍率
          transformer: '',
          readMeterMonthStart: '',
          readMeterMonthEnd: '',
          accountPeriod: '',
          eletricPriceMonth: '',
          periodStartRead: '',
          periodEndRead: '',
          currentMonthRead: '',
          remark: '',
          electricPriceMonth: '',
        },
        // fileType: ['xls', 'xlsx', 'txt', 'doc', 'docx', 'pdf', 'jpg'],
        spaceAreaDisabled: true,
        spaceAreaList: [],
        spaceAssetDisabled: true,
        spaceAssetList: [],
        spaceUnitDisabled: true,
        spaceUnitList: [],
        spaceFloorDisabled: true,
        spaceFloorList: [],
        spaceDisabled: true,
        spaceList: [], //空间列表
        companyList: [], //公司列表
        meterList: [], //电表列表
        meterTypeList: [], //电表类型
        electricMeterId: '', //电表ID
        meterReadingWarning: '',
        removeMeterNo: false,
        removeSpace: false,
        unchangeMeterNo: false,
        allMeterList: [], //完整电表
        rules: {
          electricMeterNo: [{ required: true, message: '请选择电表编号', trigger: 'blur' }],
          readMeterMonthStart: [{ required: true, message: '请选择抄表月份', trigger: 'blur' }],
          readMeterMonthEnd: [
            { required: true, message: '请选择抄表月份', trigger: 'blur' },
            { validator: this.checkEndTime, trigger: 'change' },
          ],
          // customerName: [{ required: true, message: '请选择客户名称', trigger: 'blur' }],
          periodStartRead: [{ required: true, message: '请输入期初电表读数', trigger: 'blur' }],
          periodEndRead: [
            { required: true, message: '请输入期末电表读数', trigger: 'blur' },
            { validator: this.checkEndRead, trigger: 'change' },
          ],
          currentMonthRead: [
            { required: true, message: '请设置当月读数', trigger: 'blur' },
            { required: true, validator: this.checkCurrentMonthRead, trigger: 'change' },
          ],
          readMeterDate: [{ required: true, message: '请选择抄表日期', trigger: 'blur' }],
          electricPriceMonth: [{ required: true, message: '请选择电价月份', trigger: 'blur' }],
          accountPeriod: [{ required: true, message: '请选择业务账期', trigger: 'blur' }],
        },
      };
    },
    mounted() {
      this.form.companyCode = this.userInfo.companyCode;
      this.form.electricMeterNo = this.$route.query.meterNo;
      this.form.readMeterDate = moment(new Date()).format('YYYY-MM-DD');
      this.meterTypeList = this.dictListMap['meter_type'];
      this.getMeterList();
      this.getCompany();
      //请求数据
    },
    methods: {
      //校验结束时间
      checkEndTime(rule, value, callback) {
        if (!value) {
          callback(new Error('请选择结束时间'));
        } else {
          if (!this.form.readMeterMonthStart) {
            callback(new Error('请选择开始时间！'));
          } else if (Date.parse(this.form.readMeterMonthStart) > Date.parse(value)) {
            callback(new Error('结束时间必须大于开始时间！'));
          } else {
            callback();
          }
        }
      },
      checkEndRead(rule, value, callback) {
        if (!value) {
          callback(new Error('请输入期末电表读数'));
        } else {
          if (!this.form.periodStartRead) {
            callback(new Error('请输入期初电表读数'));
          } else if (this.form.periodStartRead - 0 > value - 0) {
            callback(new Error('期末电表读数必须大于期初电表读数！'));
          } else {
            callback();
          }
        }
      },
      checkCurrentMonthRead(rule, value, callback) {
        if (!value) {
          callback(new Error('请设置当月读数'));
        } else {
          if (!this.form.currentMonthRead) {
            callback(new Error('请设置当月读数'));
          } else if (this.meterReadingWarning != null && this.meterReadingWarning - 0 < value - 0) {
            callback(new Error('当月读数超过预警值，请核实！'));
          } else {
            callback();
          }
        }
      },

      confirmClick() {
        this.$confirmAction('', '您确定要保存吗？', '确认', '返回修改').then(() => {
          this.rules.currentMonthRead[1] = {};
          this.$refs.baseInfoFormRef.validate((valid) => {
            if (valid) {
              this.registerPost();
            }
          });
        });
      },

      async registerPost() {
        this.storageAttachment = this.$refs.fileTableRef.getTableData();
        var spaceAreaName = '';
        var spaceAssetName = '';
        var spaceUnitName = '';
        var spaceFloorName = '';
        var spaceName = '';
        var electricCompanyName = '';
        if (this.form.companyCode != '') {
          let index = this.companyList.findIndex(
            (item) => item.personCompanyCode == this.form.companyCode
          );
          if (index != -1) {
            electricCompanyName = this.companyList[index].personCompanyName;
          }
        }
        if (this.form.spaceAreaId != '') {
          let index = this.spaceAreaList.findIndex((item) => item.id == this.form.spaceAreaId);
          if (index != -1) {
            spaceAreaName = this.spaceAreaList[index].name;
          }
        }
        if (this.form.spaceAssetId != '') {
          let index = this.spaceAssetList.findIndex((item) => item.id == this.form.spaceAssetId);
          if (index != -1) {
            spaceAssetName = this.spaceAssetList[index].name;
          }
        }
        if (this.form.spaceUnitId != '') {
          let index = this.spaceUnitList.findIndex((item) => item.id == this.form.spaceUnitId);
          if (index != -1) {
            spaceUnitName = this.spaceUnitList[index].name;
          }
        }
        if (this.form.spaceFloorId != '') {
          let index = this.spaceFloorList.findIndex((item) => item.id == this.form.spaceFloorId);
          if (index != -1) {
            spaceFloorName = this.spaceFloorList[index].name;
          }
        }
        if (this.form.spaceId != '') {
          let index = this.spaceList.findIndex((item) => item.id == this.form.spaceId);
          if (index != -1) {
            spaceName = this.spaceList[index].name;
          }
        }
        let params = {
          ...this.form,
          electricMeterId: this.electricMeterId,
          attachments: this.storageAttachment,
          electricCompanyNo: this.form.companyCode,
          electricCompanyName: electricCompanyName,
          spaceAreaName: spaceAreaName,
          spaceAssetName: spaceAssetName,
          spaceUnitName: spaceUnitName,
          spaceFloorName: spaceFloorName,
          spaceName: spaceName,
        };
        this.$axios.post(MeterAPI.READ_SAVE, params).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('操作成功');
            this.returnPath();
          } else {
            this.rules.currentMonthRead[1] = {
              required: true,
              validator: this.checkCurrentMonthRead,
              trigger: 'change',
            };
            if (res.data.msg != '') {
              return this.$message.error(res.data.msg);
            }
            this.$message.error('操作失败');
          }
        });
      },
      cancelClick() {
        this.returnPath();
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: false },
          },
          toPath: {
            path: '/property/meterReading',
            name: 'meterReading',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //获取电表列表数据
      async getMeterList() {
        const { data } = await this.$axios.post(MeterAPI.METER_LIST, {
          effectiveStatus: '2',
          companyCode: this.form.companyCode,
        });
        if (data.code == 0) {
          this.allMeterList = data.data;
          this.meterList = this.allMeterList;
        }
      },
      // 电表详情
      async getDetail() {
        const { data } = await this.$axios.get(
          `${MeterAPI.ELECTRIC_METER}/${this.form.electricMeterNo}`
        );
        if (data.code == 0) {
          if ((data.data.electricMeter.companyCode || '') != '') {
            this.form.companyCode = data.data.electricMeter.companyCode;
          }
          if (data.data.spaces != null && data.data.spaces.length > 0) {
            let arr = data.data.spaces[0].space.parentStr.split('/');

            if (arr.length == 5) {
              for (let i = 0; i < arr.length - 1; i++) {
                this.getSpaceType(i, arr[i]);
              }
              this.form.spaceId = arr[4];
            } else {
              for (let i = 0; i < arr.length; i++) {
                this.getSpaceType(i, arr[i]);
              }
            }
          } else {
            this.form.spaceAreaId = '';
            this.removeSpace = true;
          }
          this.electricMeterId = data.data.electricMeter.id; //电表ID
          this.meterReadingWarning = data.data.electricMeter.meterReadingWarning; //抄表预警值
          if (data.data.electricMeter.inductanceRatio != null) {
            this.form.inductanceRatio = data.data.electricMeter.inductanceRatio.toString();
          }
          if (data.data.electricMeter.loss != null) {
            this.form.loss = data.data.electricMeter.loss.toString();
          }
          if (data.data.leaseContract != null) {
            this.form.customerName = data.data.leaseContract.customerName; //客户名称
            this.form.customerCode = data.data.leaseContract.customerCode; //客户名称
          }
          this.form.electricMeterType = data.data.electricMeter.meterType || '1' + ''; //电表类型
          // this.form.loss = data.data.electricMeter.loss || '' + ''; //损耗
          // this.form.inductanceRatio = data.data.electricMeter.inductanceRatio || '' + ''; //电感比/
          this.form.transformer = data.data.electricMeter.transformer || '' + '';
          this.form.areaMeterNo = data.data.electricMeter.areaMeterNo;
          this.form.areaMeterName = data.data.electricMeter.areaMeterName;
          this.form.lineMeterNo = data.data.electricMeter.lineMeterNo;
          this.form.lineName = data.data.electricMeter.lineName || '' + '';
          this.form.transformerMeterNo = data.data.electricMeter.transformerMeterNo;
          this.form.transformerName = data.data.electricMeter.transformerName;
        }
      },
      getSpaceType(index, id) {
        console.log('设置空间值', id);
        if (index == 0) {
          this.form.spaceAreaId = id;
        } else if (index == 1) {
          this.form.spaceAssetId = id;
        } else if (index == 2) {
          this.form.spaceUnitId = id;
        } else if (index == 3) {
          this.form.spaceFloorId = id;
        }
      },

      // 电表抄表详情
      async getNewReadDetail(meterNo) {
        const { data } = await this.$axios.get(`${MeterAPI.READ_DETAIL}/${meterNo}`);
        if (data.code == 0) {
          if (data.data.readRegisterVO != null) {
            // 抄表从
            let readMeterMonthStart = moment(data.data.readRegisterVO.readMeterMonthStart)
              .add(1, 'months')
              .format('YYYY-MM-DD');
            this.form.readMeterMonthStart = moment(readMeterMonthStart)
              .startOf('month')
              .format('YYYY-MM-DD');
            // 抄表至
            let readMeterMonthEnd = moment(data.data.readRegisterVO.readMeterMonthEnd)
              .add(1, 'months')
              .format('YYYY-MM-DD');
            this.form.readMeterMonthEnd = moment(readMeterMonthEnd)
              .endOf('month')
              .format('YYYY-MM-DD');
            // 电价月份
            this.form.electricPriceMonth = moment(readMeterMonthStart).format('YYYY-MM');
            // 业务账期
            this.form.accountPeriod = moment(new Date()).format('YYYY-MM');
            // this.form.readMeterMonthStart = data.data.readRegisterVO.readMeterMonthStart;
            // this.form.readMeterMonthEnd = data.data.readRegisterVO.readMeterMonthEnd;
            this.form.periodStartRead = '' + (data.data.readRegisterVO.periodEndRead || '');
            this.form.periodEndRead = '';
            this.form.currentMonthRead = '' + (data.data.readRegisterVO.currentMonthRead || '');
            // this.form.remark = data.data.readRegisterVO.remark;
            this.storageAttachment = data.data.readRegisterVO.attachments;
          }
        }
      },
      // 根据片区查询电表
      async findSpaceByMeterNo(params) {
        params.energyType = '02';
        const { data } = await this.$axios.post(MeterAPI.ENERGY_SPACE, params);
        this.meterList = [];
        if (data.code == 0) {
          if (data.data.length == 1) {
            this.form.electricMeterNo = data.data[0].energyId + '';
          }
          data.data.forEach((item) => {
            this.meterList.push({
              id: item.energyId.toString(),
              meterNo: item.energyCode,
            });
          });
        }
      },
      //获取公司信息
      async getCompany() {
        const { data } = await this.$axios.post(MeterAPI.GET_LIST_PERSON, {
          id: this.userInfo.userCode,
        });
        if (data.code == 0) {
          this.companyList = data.data.personCompanyInfo;
          this.form.companyCode = this.userInfo.companyCode;
        }
      },
      // 获取片区数据
      async getArea(value, type) {
        const { data } = await this.$axios.get(MeterAPI.GET_AREA, {
          id: value,
          companyNo: this.form.companyCode,
          effective: false,
        });
        if (data.code == 0) {
          console.log('获取片区数据', type);
          if (type == 'area') {
            this.spaceAreaList = data.data;
            if (this.spaceAreaList.length <= 0) {
              this.form.spaceAreaId = '';
              this.form.spaceAssetId = '';
              this.form.spaceUnitId = '';
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'asset') {
            this.spaceAssetList = data.data;
            if (this.spaceAssetList.length <= 0) {
              this.form.spaceAssetId = '';
              this.form.spaceUnitId = '';
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'unit') {
            this.spaceUnitList = data.data;
            if (this.spaceUnitList.length <= 0) {
              this.form.spaceUnitId = '';
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'floor') {
            this.spaceFloorList = data.data;
            if (this.spaceFloorList.length <= 0) {
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'space') {
            this.spaceList = data.data;
            if (this.spaceList.length <= 0) {
              this.form.spaceId = '';
            }
          }
        }
      },

      // 区域改变，重置电表编号
      resetMeterNo(value) {
        console.log('区域改变了', value);
        this.removeMeterNo = true;
        this.removeSpace = true;
        this.form.electricMeterNo = '';
        console.log('1111111111');
      },
    },
    watch: {
      'form.electricMeterNo': {
        handler(newVal, oldVal) {
          console.log('电表编号改变了', newVal);
          if (newVal != oldVal && newVal != '') {
            this.form.customerName = ''; //客户名称
            this.form.electricMeterType = ''; //电表类型
            this.form.loss = ''; //损耗
            this.form.inductanceRatio = ''; //电感比/倍率
            this.form.transformer = '';
            this.form.readMeterMonthStart = '';
            this.form.readMeterMonthEnd = '';
            this.form.periodStartRead = '';
            this.form.periodEndRead = '';
            this.form.currentMonthRead = '';
            this.unchangeMeterNo = true;
            this.getDetail(newVal);
            this.getNewReadDetail(newVal);
          } else {
            if (!this.removeMeterNo) {
              this.spaceAssetDisabled = true;
              this.spaceUnitDisabled = true;
              this.spaceFloorDisabled = true;
              this.spaceDisabled = true;
              this.form.spaceAreaId = '';
              this.form.spaceAssetId = '';
              this.form.spaceUnitId = '';
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
              this.spaceAssetList = [];
              this.spaceUnitList = [];
              this.spaceFloorList = [];
              this.spaceList = [];
              this.removeMeterNo = false;
            }
            this.form.customerName = ''; //客户名称
            this.form.electricMeterType = ''; //电表类型
            this.form.loss = ''; //损耗
            this.form.inductanceRatio = ''; //电感比/倍率
            this.form.transformer = '';
            this.form.readMeterMonthStart = '';
            this.form.readMeterMonthEnd = '';
            this.form.periodStartRead = '';
            this.form.periodEndRead = '';
            this.form.currentMonthRead = '';
            this.form.remark = '';
            this.meterList = this.allMeterList;
          }
        },
      },
      'form.companyCode': {
        handler: function (newVal) {
          if (this.removeSpace) {
            this.form.spaceAreaId = '';
            this.form.spaceAssetId = '';
            this.form.spaceUnitId = '';
            this.form.spaceFloorId = '';
            this.form.spaceId = '';
            this.removeSpace = false;
          }
          if (newVal != '') {
            this.spaceAreaDisabled = false;
            this.getArea('0', 'area');
          } else {
            this.spaceAreaDisabled = true;
            this.spaceAssetDisabled = true;
            this.spaceUnitDisabled = true;
            this.spaceFloorDisabled = true;
            this.spaceDisabled = true;
            this.spaceAreaList = [];
            this.spaceAssetList = [];
            this.spaceUnitList = [];
            this.spaceFloorList = [];
            this.spaceList = [];
            this.meterList = this.allMeterList;
          }
        },
      },
      'form.spaceAreaId': {
        handler: function (newVal) {
          if (this.removeSpace) {
            this.form.spaceAssetId = '';
            this.form.spaceUnitId = '';
            this.form.spaceFloorId = '';
            this.form.spaceId = '';
            this.removeSpace = false;
          }
          if (newVal != '') {
            this.spaceAssetDisabled = false;
            this.getArea(newVal, 'asset');
            this.meterList = this.allMeterList;
          } else {
            // 片区改变，电表回归最初列表
            this.meterList = this.allMeterList;
            this.spaceAssetDisabled = true;
            this.spaceUnitDisabled = true;
            this.spaceFloorDisabled = true;
            this.spaceDisabled = true;
            this.spaceAssetList = [];
            this.spaceUnitList = [];
            this.spaceFloorList = [];
            this.spaceList = [];
          }
        },
      },
      'form.spaceAssetId': {
        handler: function (newVal) {
          if (this.removeSpace) {
            this.form.spaceUnitId = '';
            this.form.spaceFloorId = '';
            this.form.spaceId = '';
            this.removeSpace = false;
          }
          if (newVal != '') {
            this.spaceUnitDisabled = false;

            this.getArea(newVal, 'unit');
            if (this.spaceAssetList.length > 0) {
              let index = this.spaceAssetList.findIndex((item) => item.id == newVal);
              if (index != -1) {
                if (this.spaceAssetList[index].leafFlag == 0) {
                  this.findSpaceByMeterNo({ spaceId: newVal });
                } else {
                  this.meterList = this.allMeterList;
                }
              }
            }
          } else {
            this.spaceUnitDisabled = true;
            this.spaceFloorDisabled = true;
            this.spaceDisabled = true;
            this.spaceUnitList = [];
            this.spaceFloorList = [];
            this.spaceList = [];
          }
        },
      },
      'form.spaceUnitId': {
        handler: function (newVal) {
          if (this.removeSpace) {
            this.form.spaceFloorId = '';
            this.form.spaceId = '';
            this.removeSpace = false;
          }
          if (newVal != '') {
            this.spaceFloorDisabled = false;
            this.getArea(newVal, 'floor');
            if (this.spaceUnitList.length > 0) {
              let index = this.spaceUnitList.findIndex((item) => item.id == newVal);
              if (index != -1) {
                if (this.spaceUnitList[index].leafFlag == 0) {
                  this.findSpaceByMeterNo({ spaceId: newVal });
                } else {
                  this.meterList = this.allMeterList;
                }
              }
            }
          } else {
            this.spaceFloorDisabled = true;
            this.spaceDisabled = true;
            this.spaceFloorList = [];
            this.spaceList = [];
          }
        },
      },
      'form.spaceFloorId': {
        handler: function (newVal) {
          if (this.removeSpace) {
            this.form.spaceId = '';
            this.removeSpace = false;
          }
          if (newVal != '') {
            this.spaceDisabled = false;
            this.getArea(newVal, 'space');
            if (this.spaceFloorList.length > 0) {
              let index = this.spaceFloorList.findIndex((item) => item.id == newVal);
              if (index != -1) {
                if (this.spaceFloorList[index].leafFlag == 0) {
                  this.findSpaceByMeterNo({ spaceId: newVal });
                } else {
                  this.meterList = this.allMeterList;
                }
              }
            }
          } else {
            this.spaceDisabled = true;
            this.spaceList = [];
          }
        },
      },
      'form.spaceId': {
        handler: function (newVal) {
          if (newVal != '') {
            this.findSpaceByMeterNo({ spaceId: newVal });
          }
        },
      },
      'form.periodEndRead': {
        handler: function (newVal) {
          if (newVal != '') {
            if (this.form.periodStartRead != '') {
              this.form.currentMonthRead =
                '' + (this.form.periodEndRead - this.form.periodStartRead).toFixed(2);
            } else {
              this.form.currentMonthRead = '' + this.form.periodEndRead.toFixed(2);
            }
          } else {
            this.form.currentMonthRead = '';
          }
        },
      },
      'form.periodStartRead': {
        handler: function (newVal) {
          if (newVal != '') {
            if (this.form.periodEndRead != '') {
              this.form.currentMonthRead =
                '' + (this.form.periodEndRead - this.form.periodStartRead).toFixed(2);
            } else {
              this.form.currentMonthRead = '';
            }
          } else {
            this.form.currentMonthRead = '';
          }
        },
      },
    },
  };
</script>
<style scoped lang="scss">
  .error-prompt {
    position: relative;
  }

  .error-prompt-test {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }

  .page {
    background-color: white;
    margin-top: 0px;
    padding: 20px;
    height: 100%;
    top: 0;

    .title {
      font-size: 20px;
      color: black;
      margin-left: 10px;
      margin-bottom: 10px;
      font-weight: bolder;
    }
  }

  .bottomButtons {
    margin-top: 20px;
  }
</style>
